import type { TagProduct } from '~~/types/integrations/tagManager/TagProduct';
import type { BeginCheckoutEventInfo, BeginCheckoutCategory, BeginCheckoutEcommerceType, BeginCheckoutInformation } from '~~/types/integrations/tagManager/BeginCheckoutTypes';
import {
  EVENT_BEGIN_CHECKOUT,
  EVENT_BEGIN_CHECKOUT_DEFAULT_EVENT_TYPE,
  PRIMARY_CATEGORY,
} from '~~/constants/googleTagManager';

export const buildBeginCheckoutTags = ({
  tagProducts,
  cartInformation,
}: {
  tagProducts: TagProduct[];
  cartInformation: BeginCheckoutInformation;
}) => ({
  event: EVENT_BEGIN_CHECKOUT,
  eventInfo: {
    detail: EVENT_BEGIN_CHECKOUT,
  } as BeginCheckoutEventInfo,
  category: {
    event_type: EVENT_BEGIN_CHECKOUT_DEFAULT_EVENT_TYPE,
    primary_category: PRIMARY_CATEGORY,
  } as BeginCheckoutCategory,
  ecommerce: {
    items: tagProducts,
    ...cartInformation,
  } as BeginCheckoutEcommerceType,
});
